import { render } from "./BotBar.vue?vue&type=template&id=79e2a3bc&scoped=true"
import script from "./BotBar.vue?vue&type=script&lang=js"
export * from "./BotBar.vue?vue&type=script&lang=js"

import "./BotBar.vue?vue&type=style&index=0&id=79e2a3bc&scoped=true&lang=css"

import exportComponent from "/Users/otherview/go/src/github.com/otherview/blockstory/web/home/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79e2a3bc"]])

export default __exports__